import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficeTimecardHistoryList extends Layout {
    layoutheaderTimecard: LayoutHeader;
    sourceTimecardHist: DataSource;
    tableTimecard: Table;
}
